<!-- 查询缴费 -->
<template>
  <div id="searchPay">
    <div>
      <!-- 头部地理位置和搜索框 -->
      <div class="head">
        <!-- 顶部NavBar 开始 -->
        <van-nav-bar
          :title="$t('searchPay.title')"
          :left-text="$t('main.return')"
          left-arrow
          style="background-color: rgba(255,255,255,0);"
          @click-left="onClickLeft"
        />
      </div>
    </div>
    <div id="listLoading">
      <van-loading
        v-if="loading"
        type="spinner"
      />
    </div>
    <div class="outboxstyle">
      <div class="boxstyle">
        <van-row>
          <van-col :span="24">
            <div class="clearfix">
              <!-- <img :src="iconList[2]" alt="" class="icon img left"> -->
            </div>
            <van-field
              v-model="queryForm.objectName"
              name="关键字"
              label=""
              :placeholder="$t('searchPay.input')"
              class="picker"
              @change="search"
            />
          </van-col>
        </van-row>
        <!-- <p style="line-height:50px">已选<span style="color:#3BA4F2">&nbsp;&nbsp;{{ count }}&nbsp;&nbsp;</span>项,合计:<span style="float:right;color:red">¥&nbsp;{{ total }}</span></p> -->
      </div>
      <van-list
        v-model="isUpLoading"
        class="list"
        :immediate-check="false"
        finished-text="没有更多了"
        :finished="upFinished"
        :offset="offset"
        @load="onLoad"
      >
        <div v-for="(item, index) in list" :key="index">
          <van-cell-group :class="index===activeIndex?'group':'group2'" @click="choose(item,index)">
            <img :src="index===activeIndex?imageL[1] : imageL[2]" class="line">
            <div class="total">
              <img :src="imgList[0]">
              {{ item.projectName }}
            </div>
            <van-cell :title="$t('pay.tobe-pay')" :value="'¥'+fenToYuan(item.payamt)" />
            <!-- <van-cell title="减免金额" :value="'¥'+fenToYuan(item.rebateamt)" /> -->
            <!-- <van-cell title="已缴金额" :value="'¥'+fenToYuan(item.paidAmtStr)" /> -->
            <van-cell :title="$t('pay.unpaid-amount')" :value="'¥'+fenToYuan(item.unpaidamt)" />
            <van-cell :title="$t('pay.full-payment')">
              <van-switch
                v-model="item.fullPay"
                size="24px"
                @input="onInput(item, index)"
              />
            </van-cell>
            <!-- <van-cell id="totalpay" title="缴费金额" :value="'¥'+fenToYuan(item.payNowStr)" /> -->
            <van-cell :title="$t('pay.payment-amount')">
              <!-- 使用 right-icon 插槽来自定义右侧图标 -->
              <template #default>
                <span v-if="item.fullPay" style="color:#3BA4F2">¥{{ fenToYuan(item.unpaidamt) }}</span>
                <span v-if="!item.fullPay" style="color:#3BA4F2">¥{{ item.payNowStr }}</span>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </van-list>
    </div>
    <div class="bottom">
      <van-button type="info" size="large" :loading="nextLoading" class="bottombutton" @click="nextStep">{{ $t('main.next') }}</van-button>
    </div>
    <van-dialog v-model="show" :title="$t('searchPay.fix')" show-cancel-button :before-close="chargeBtn">
      <!-- 允许输入正整数，调起纯数字键盘 -->
      <van-field v-model="money" style="width: 90%;margin: 20px;border: 1px solid #eee;" type="digit" />
    </van-dialog>
    <!-- 回到顶部按钮 -->
    <v-top />
  </div>
</template>

<script>
// import { pageListReiForm } from '@/api/reiform'
//
// queryDetail createQueryPaymentOrder
import { getList } from '@/api/queryPayment/queryPayment'
import { fenToYuan } from '@/utils/commonUtils'
// import moment from 'moment/moment'
import { Dialog } from 'vant'
import { Toast } from 'vant'
export default {
  name: 'Project',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast
  },
  data() {
    return {
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      chooseItem: {},
      activeIndex: '',
      textForm: {
        projectName: '',
        payamtStr: 0,
        paidAmtStr: 0,
        rebateAmountStr: 0,
        unPaidAmtStr: 0,
        actualPayAmountStr: 0,
        nameListId: '',
        projectId: ''
      },
      queryForm: {
        objectName: '',
        pageSize: 10,
        pageCurrent: 1,
        schoolCode: this.$store.state.settings.schoolCode
      },
      diyFormList: [],
      value: '',
      showPicker: false,
      checked: false,
      imgList: [
        require('../../assets/newImages/icon4.png'),
        require('../../assets/newImages/icon6.png'),
        require('../../assets/newImages/orderList4.png')

      ],
      imageL: [
        require('../../assets/newImages/home_icon6.png'),
        require('../../assets/newImages/right.png'),
        require('../../assets/newImages/rightbefore.png')
      ],
      list: [],
      total: 0,
      show: false,
      money: '',
      moneyindex: '',
      count: 0,
      nextLoading: false,
      sectionAmount: 0,
      allAmount: 0,
      loading: false,
      id: ''
    }
  },
  watch: {
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background: #F5F5F5')
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // list到底
    onLoad() {
      console.log('出发')
      console.log('this.queryForm.objectName', this.queryForm.objectName)
      if (this.queryForm.objectName !== '') {
        console.log('出发2')
        this.loading = true
        setTimeout(() => {
          this.queryForm.pageCurrent = this.queryForm.pageCurrent + 1
          getList(
            this.queryForm
          ).then(
            response => {
              if (response.data.records.length === 0) {
                this.upFinished = true
                this.loading = false
                this.isUpLoading = false
                // Toast.fail('没有更多了')
                // this.conheight.background = '#EFF6FF'
                return false
              } else {
                const newlist = response.data.records
                this.newlist.forEach(item => {
                  this.$set(item, 'fullPay', true)
                })
                this.list = this.list.concat(newlist)
                this.isUpLoading = false
                this.loading = false
                Toast.success(this.$t('msg.loadSuccess')) // 弹出
              }
            }
          ).catch(err => {
            Toast.fail(err.message)
            this.isUpLoading = false
            this.loading = false
          })
        }, 500)
      } else {
        this.isUpLoading = false
        this.loading = false
        return
      }
    },
    search() {
      if (this.queryForm.objectName === '') {
        Toast.fail(this.$t('msg.keyEmpty'))
      } else {
        this.loading = true
        this.queryForm.pageCurrent = 1
        getList(this.queryForm).then(response => {
          console.log('查询列表')
          console.log(response.data)
          this.list = response.data.records
          this.total = response.data.total
          this.list.forEach(item => {
            this.$set(item, 'fullPay', true)
          })
          this.loading = false
          Toast.success(this.$t('msg.loadSuccess'))
        })
      }
    },
    // 选择
    choose(obj, index) {
      this.chooseItem = obj
      this.activeIndex = index
      obj.show = !obj.show
      this.id = obj.id
    },
    onInput(obj, index) {
      console.log(obj, index)
      // if (obj.payLimit === '-1' || obj.payLimit === '0' || obj.payLimit === -1 || obj.payLimit === 0 || obj.payLimit === null) {
      //   obj.fullPay = true
      //   Toast.fail('该缴费项目不允许部分缴费')
      //   return
      // }
      // 阻止事件穿透
      event.stopPropagation()
      this.moneyindex = index
      if (obj.fullPay === false) {
        this.show = true
        // 获取当前数据的未缴金额
        this.money = this.fenToYuan(obj.unpaidamt)
        // 获取当前数据的index
        // this.calculationData()
      } else {
        obj.fullPay === true
        // this.$set(this.list[this.moneyindex], 'fullPay', true)
        console.log(obj.fullPay)
        obj.payNowStr = obj.unpaidamt
        // this.calculationData()
      }
    },
    chargeBtn(action, done) {
      // 确认or取消
      if (action === 'cancel') { // 取消按钮
        this.list[this.moneyindex].fullPay = true
        // this.calculationData()
        done()
      } else if (action === 'confirm') { // 确定按钮
        if (this.money * 100 >= this.list[this.moneyindex].unpaidamt) {
          console.log('money', this.money)
          console.log('this.list[this.moneyindex].unpaidamt', fenToYuan(this.list[this.moneyindex].unpaidamt))
          Toast.fail(this.$t('msg.amountOver'))
          done(false)
          return false
        }
        // 向后端传值并关闭dialog弹出框
        this.list[this.moneyindex].payNowStr = this.money
        // this.calculationData()
        this.$set(this.list[this.moneyindex], 'fullPay', false)
        // this.list[this.moneyindex].fullPay = false
        this.show = false
        done()
      }
    },
    // 获取数据
    // getWaitingPayList() {
    //   this.loading = true
    //   setTimeout(() => {
    //     getWaitingPayList(
    //       this.$store.state.settings.schoolCode,
    //       this.$store.getters.idserial
    //     ).then(response => {
    //       this.list = response.data
    //       this.loading = false
    //       Toast.success('加载成功')
    //       for (let i = 0; i < this.list.length; i++) {
    //         this.list[i].show = false
    //         this.$set(this.list[i], 'fullPay', true)
    //         // this.$set(this.list[i], 'paidamt', fenToYuan(this.list[i].paidamt))
    //         // this.$set(this.list[i], 'rebateamt', fenToYuan(this.list[i].rebateamt))
    //         // this.$set(this.list[i], 'payamt', fenToYuan(this.list[i].payamt))
    //         if (this.list[i].payNowStr === null) {
    //           this.list[i].payNowStr = this.list[i].unpaidamt
    //         }
    //       }
    //     }).catch(error => {
    //       Toast.fail(error)
    //     })
    //   }, 500)
    // },
    nextStep() {
      console.log('item', this.chooseItem)
      if (!this.chooseItem.id) {
        Toast.fail(this.$t('order.payment-input'))
      } else {
        const temp = {}
        temp.id = this.chooseItem.id
        // 全额缴费
        if (this.chooseItem.fullPay === true) {
          temp.actualPayAmountStr = (this.chooseItem.unpaidamt) / 100 + ''
        } else {
          // 部分缴费
          temp.actualPayAmountStr = this.chooseItem.payNowStr
        }
        this.$router.push({ path: 'searchPayDetail', query: {
          actualPayAmountStr: temp.actualPayAmountStr,
          id: temp.id,
          projectId: this.chooseItem.projectId
        }
        })
      }

      // queryDetail(this.id).then(response => {
      //   this.textForm.nameListId = this.id
      //   this.textForm.projectName = response.data.projectName
      //   this.textForm.payamtStr = response.data.payamtStr
      //   this.textForm.paidAmtStr = response.data.paidAmtStr
      //   this.textForm.rebateAmountStr = response.data.rebateAmountStr
      //   this.textForm.unPaidAmtStr = response.data.unPaidAmtStr
      //   // 自定义表单
      //   this.temp = response.data
      //   this.temp.formAssemblyVoList.forEach(item => {
      //     var obj = {}
      //     obj.id = item.id
      //     obj.type = item.assemblyType
      //     obj.placeholder = item.tipsInfo
      //     obj.pros = item.mustStatus
      //     obj.label = item.showName
      //     obj.key = item.assemblyKey
      //     if (obj.type === 'input') {
      //       this.$set(this.diyRules, obj.key, [{ required: true, message: '必填项不能为空', trigger: 'blur' }])
      //     } else if (obj.type === 'select') {
      //       obj.options = []
      //       this.$set(this.diyRules, obj.key, [{ required: true, message: '必填项不能为空', trigger: 'change' }])
      //       item.listAssemblyDetail.forEach(op => {
      //         var optionObj = {}
      //         optionObj.id = op.id
      //         optionObj.key = op.detailValue
      //         optionObj.label = op.showDetail
      //         optionObj.value = op.detailValue
      //         obj.options.push(optionObj)
      //       })
      //     }
      //     this.diyFormList.push(obj)
      //   })
      //   console.log('qujiaofei')
      //   console.log(this.diyFormList)
      //   this.dialogShow = true

      //   var createOrderVO = {}
      //   createOrderVO.payProjectVO = {}
      //   createOrderVO.payProjectVO.nameListId = this.textForm.nameListId
      //   createOrderVO.payProjectVO.actualPayAmountStr = this.textForm.actualPayAmountStr
      //   var payUserAssemblyDataVO = {}
      //   var otherDataArray = []
      //   this.diyFormList.forEach(item => {
      //     if (item.key === 'NAME') {
      //       payUserAssemblyDataVO.name = item.value
      //     } else if (item.key === 'SEX') {
      //       payUserAssemblyDataVO.sex = item.value
      //     } else if (item.key === 'IDSERIAL') {
      //       payUserAssemblyDataVO.idserial = item.value
      //     } else if (item.key === 'IDNUMBER') {
      //       payUserAssemblyDataVO.idNumber = item.value
      //     } else if (item.key === 'PHONE') {
      //       payUserAssemblyDataVO.phone = item.value
      //     } else if (item.key === 'EMAIL') {
      //       payUserAssemblyDataVO.email = item.value
      //     } else {
      //       var obj = {}
      //       obj.key = item.key
      //       obj.value = this.diyTemp[item.pros]
      //       otherDataArray.push(obj)
      //     }
      //     payUserAssemblyDataVO.otherData = JSON.stringify(otherDataArray)
      //   })
      //   createOrderVO.payUserAssemblyDataVO = payUserAssemblyDataVO
      //   createQueryPaymentOrder(createOrderVO).then((response) => {
      //     console.log(response)
      //     var amount = fenToYuan(response.data.amount)
      //     this.$router.push({ path: 'person', query: { 'amount': amount, 'projectId': this.textForm.projectId, 'order': response.data.orderNo }})
      //   })
      // })
    },
    checkRules(payList) {
      var errorFlag = true
      var list = payList
      if (list.length < 1) {
        Toast.fail('请选择待缴费记录')
        return false
      }
      // 如果部分缴费 判断是否输入金额为空
      list.forEach(item => {
        if (item.fullPay === false) {
          if (item.payNowStr === null || item.payNowStr === '' || item.payNowStr === undefined) {
            errorFlag = false
          }
        }
      })
      if (errorFlag === false) {
        Toast.fail('部分缴费不能为0或空')
        return false
      }
      return true
    },
    // 返回
    onClickLeft() {
      // this.$router.push({ path: '/todo' })
      this.$router.push({ path: '/home' })
    },
    // 金钱转换
    fenToYuan(val) {
      return fenToYuan(val)
    },
    // 计算选中的数据
    calculationData() {
      this.total = 0
      this.count = 0
      this.allAmount = 0
      this.sectionAmount = 0
      for (let i = 0; i < this.list.length; i++) {
        const allPay = []
        const sectionPay = []
        if (this.list[i].show === true) {
          if (this.list[i].fullPay === false) {
            sectionPay.push(this.list[i])
            for (let j = 0; j < sectionPay.length; j++) {
              this.sectionAmount += Number(sectionPay[j].payNowStr)
            }
          } else {
            allPay.push(this.list[i])
            for (let k = 0; k < allPay.length; k++) {
              this.allAmount += Number(allPay[k].payNowStr)
            }
          }
          this.count += 1
        }
      }
    //   this.allAmount = fenToYuan(this.allAmount)
    //   this.total = Number(this.sectionAmount) + Number(this.allAmount)
    }
  }
}
</script>
<style scoped lang="scss">
#searchPay   {
  position: relative;
  background-color: #eff6ff;
  .head {
    height: 86px;
    width: 100%;
    background:linear-gradient(135deg, #3793e5 0%, #4046a6 100%);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .van-switch {
    font-size: 24px;
    height: 22px;
    line-height: 24px;
  }
  .van-cell__value {
    height: 24px;
  }
}
.outboxstyle {
  // padding: 0px 10px 10px 10px;
  background-color: #F5F5F5;
  border-radius: 10px;
  margin-top: -20px;
  margin-bottom: 100px;
  width: 100%;
  height: 100%;
}
.boxstyle {
  font-size:16px;
  height:50px;
  background:#fff;
  border-radius:10px 10px 0px 0px;
  padding:0px 30px
}
.buttontext{
  width:90px;
  border-radius:5px
}
.bottom{
  width: 100%;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  height: 80px;
  z-index: 999;
}
.bottombutton{
  margin: 20px;
  width:90%;
  height: 40px;
}
.van-cell__value {
  span{
    color: #333333;
  }
}
#totalpay {
  .van-cell__value {
  span{
    color: #3BA4F2;
  }
}
}
.group {
  padding: 0px 20px 20px 20px;
  border-radius: 10px;
  margin: 20px 20px;
  border:1px solid #3BA4F2
}
.group2 {
  padding: 0px 20px 20px 20px;
  border-radius: 10px;
  margin: 20px 20px;
  border:1px solid #eeeeee
}
.line{
  width:40px;
  position:absolute;
  right:0;
  top:-0;
  z-Index:2;
}
.total{
  font-size:18px;
  line-height:70px;
  font-weight:700;
  display: flex;
  align-items: center;
  img{
    align-items: center;
    margin:0 20px 0 10px;
    width:40px;
  }
}
</style>
<style lang="scss">
.van-nav-bar .van-icon {
    color: #ffffff;
}
.van-nav-bar__title {
    color: #ffffff;
}
.van-nav-bar__text {
    color: #ffffff;
}
[class*='van-hairline']::after {
    border: none;
}
.van-nav-bar {
  height: 80px;
}
.van-switch__node {
  width: 20px !important;
  height: 20px !important;
  left: 2px;
}
#listLoading .van-loading{
    position: fixed !important;
    color: #c8c9cc !important;
    font-size: 0;
    vertical-align: middle;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 80px;
    background: #333333;
    opacity: 0.8;
    border-radius: 10px;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
#listLoading .van-loading__spinner {
      color: rgb(255, 255, 255);
      width: 40px !important;
      height: 40px !important;
      margin: 20px !important;
  }
</style>
